module.exports = "<div class=\"bar\">\n  <div class=\"fill\"></div>\n</div>\n<div class=\"thumb-container\">\n  <div class=\"thumb\"></div>\n</div>\n"